/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  FeatureNamesList
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Feature Flags for User
 */
export const features = (

 signal?: AbortSignal
) => {


      return axiosClient<FeatureNamesList>(
      {url: `/features`, method: 'GET', signal
    },
      );
    }




export const getFeaturesQueryKey = () => {
    return [
    'features'
    ] as const;
    }


export const getFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof features>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof features>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFeaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof features>>> = ({ signal }) => features(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof features>>, TError, TData>
}

export type FeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof features>>>
export type FeaturesQueryError = ErrorType<unknown>


/**
 * @summary Feature Flags for User
 */

export function useFeatures<TData = Awaited<ReturnType<typeof features>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof features>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFeaturesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






